/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiWebhookRequest } from './ApiWebhookRequest';
import {
    ApiWebhookRequestFromJSON,
    ApiWebhookRequestFromJSONTyped,
    ApiWebhookRequestToJSON,
    ApiWebhookRequestToJSONTyped,
} from './ApiWebhookRequest';

/**
 * 
 * @export
 * @interface ApiWebhookRequestsPage
 */
export interface ApiWebhookRequestsPage {
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookRequestsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookRequestsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookRequestsPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiWebhookRequest>}
     * @memberof ApiWebhookRequestsPage
     */
    content: Array<ApiWebhookRequest>;
}

/**
 * Check if a given object implements the ApiWebhookRequestsPage interface.
 */
export function instanceOfApiWebhookRequestsPage(value: object): value is ApiWebhookRequestsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ApiWebhookRequestsPageFromJSON(json: any): ApiWebhookRequestsPage {
    return ApiWebhookRequestsPageFromJSONTyped(json, false);
}

export function ApiWebhookRequestsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhookRequestsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiWebhookRequestFromJSON)),
    };
}

export function ApiWebhookRequestsPageToJSON(json: any): ApiWebhookRequestsPage {
    return ApiWebhookRequestsPageToJSONTyped(json, false);
}

export function ApiWebhookRequestsPageToJSONTyped(value?: ApiWebhookRequestsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiWebhookRequestToJSON)),
    };
}

